import { render, staticRenderFns } from "./WidgetVehiculos.vue?vue&type=template&id=3886ed77&lang=pug"
import script from "./WidgetVehiculos.vue?vue&type=script&lang=js"
export * from "./WidgetVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports